import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import { baseUrl } from "../../shared/baseURL";

export const courseByEventsSetData = (courseByEvents) => {
  return {
    type: actionType.COURSE_BY_EVENTS_SET_DATA,
    courseByEvents: courseByEvents,
  };
};

export const courseByEventsFailData = (error) => {
  return {
    type: actionType.COURSE_BY_EVENTS_FAIL_DATA,
    error: error,
  };
};

export const courseByEventsLoading = () => {
  return {
    type: actionType.COURSE_BY_EVENTS_LOADING,
  };
};

export const courseByEventsGetData = (data) => {
  return (dispatch) => {
    dispatch(courseByEventsLoading());
    axios
      .get(baseUrl + `/courses_event?event_id=${data.id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(courseByEventsSetData(res.data));
      })
      .catch((error) => dispatch(courseByEventsFailData(error)));
  };
};
